import { useState } from "react";

export default function SurahImage({ src, title }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className="rounded-2xl bg-white/70 dark:bg-zinc-900/40 ring-1 ring-black/10 dark:ring-white/10 p-4">
        <div className="text-sm font-semibold mb-2">{title}</div>
        <div className="text-xs text-zinc-600 dark:text-zinc-300">
          Image unavailable, but the verses are still powerful. You can read them by searching for "{title}" online.
        </div>
        <div className="mt-3 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <div className="text-xs text-blue-700 dark:text-blue-300">
            The verses are still with you. Recite them from memory or continue to the next step.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl bg-white/70 dark:bg-zinc-900/40 ring-1 ring-black/10 dark:ring-white/10 p-4">
      <div className="text-sm font-semibold mb-3">{title}</div>

      {!loaded && (
        <div className="w-full h-48 bg-zinc-200 dark:bg-zinc-800 rounded-xl animate-pulse mb-3" />
      )}

      <img
        src={src}
        alt={title}
        className={`w-full rounded-xl transition-opacity ${loaded ? "opacity-100" : "opacity-0 absolute"}`}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={() => setFailed(true)}
      />

      <div className="mt-2 text-xs text-zinc-500 dark:text-zinc-400">
        Read slowly and reflect.
      </div>
    </div>
  );
}
